import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import * as Dati from "src/Dati";
import * as DatiFide from "src/DatiFide";
import * as Glob from "src/Globale";
import { Trad } from "src/components/";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import { _Accordion, _AddClientButton, _ButtonAPI } from "..";
import { _Autocomplete } from "../../form";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

export const _ExposureLimitAccordion = (): JSX.Element => {
    const history = useHistory();
    const { ShowDialog } = useContext(AlertDialogContext);

    const [formData, setFormData] = useReducerOnChange<DatiFide.CDatiFideAffidamento>({
        ...new DatiFide.CDatiFideAffidamento(),
        ID_AnagDa: Glob.GetSessione().ID_Anag
    });

    const getFormData = (): Dati.CIngrAPI<DatiFide.CDatiFideAffidamento> => {
        const data = new Dati.CIngrAPI<DatiFide.CDatiFideAffidamento>();
        data.Dato = formData;

        return data;
    };

    const onClickSave = (data: DatiFide.CRisAPIDatoTipi_FideAffidamento) => {
        if (data.Errore) {
            ShowDialog("ERRORE", Trad.Trad(data.ErrTesto), "error");
        } else {
            history.push(`/anagrafica/${formData.ID_AnagA}/fideaffidamento/${data.ID_Chiave}`);
        }
    };

    const onApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const onAddClient = (val: string) => {
        setFormData({ Type: "OnChangeFromValue", Name: "ID_AnagA", Value: val });
    };

    return (
        <_Accordion Title="Affidamento" Id="limitOfExposure" defaultExpanded>
            <Grid container>
                <Grid item xs={12}>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Value={formData.ID_AnagDa}
                                    Name="ID_AnagDa"
                                    Label="Affidatario"
                                    Disabled={!Glob.AzioneAbilitata("FideAffidamentoID_AnagDa", 2)}
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_AddClientButton OnAddClient={onAddClient}>
                                    <_Autocomplete
                                        Value={formData.ID_AnagA}
                                        Name="ID_AnagA"
                                        Label="Affidato"
                                        OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                        Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    />
                                </_AddClientButton>
                            </Grid>
                        </Grid>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <_Autocomplete
                                    Value={formData.ListaBinderJSON ?? "[]"}
                                    Name="ListaBinderJSON"
                                    Label="ListaBinder"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url={`/api/FideAffidamento/ListaBinderDisponibili?id_AnagDa=${formData.ID_AnagDa}`}
                                    Multiple
                                    SearchInput
                                    TranslationsOff
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={4} justify="flex-end">
                            <Grid item>
                                <_ButtonAPI
                                    Testo={Trad.Trad("Nuovo")}
                                    URL="/api/fideaffidamento"
                                    OnInvio={getFormData}
                                    OnClick={onClickSave}
                                    OnErrore={onApiError}
                                    Attivo={!!(formData.ID_AnagA && formData.ID_AnagDa)}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        </_Accordion>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/NewPolicy/ExposureLimitAccordion.tsx